import { BaseDto } from "./base.dto";
import { StockDto } from './stock.dto';
import { StockLevelDto } from './stockLevel.dto';
import { StockLocationDto } from './stockLocation.dto';
import { StockUnitDto } from './stockUnit.dto';

export class StockLevelDetailDto extends BaseDto{
    stockLevel?: StockLevelDto;
    stockLevelId: number;
    stockUnit?: StockUnitDto;
    stockUnitId: number;
    stock?: StockDto;
    stockId: number;
    stockLocation?: StockLocationDto;
    stockLocationId: number;
    quantity: number;
    outOfStock: boolean;
    caseQty: number;
    unitQty: number;
    splitQty: number;
    totalValue: number;
    totalAMT: number;
    isStockFromRecipe?: boolean;
}
